var i = Object.defineProperty;
var r = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var o = (a, e, t) => e in a ? i(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t, h = (a, e) => {
  for (var t in e || (e = {}))
    s.call(e, t) && o(a, t, e[t]);
  if (r)
    for (var t of r(e))
      c.call(e, t) && o(a, t, e[t]);
  return a;
};
var g = (a, e) => {
  var t = {};
  for (var l in a)
    s.call(a, l) && e.indexOf(l) < 0 && (t[l] = a[l]);
  if (a != null && r)
    for (var l of r(a))
      e.indexOf(l) < 0 && c.call(a, l) && (t[l] = a[l]);
  return t;
};
import * as n from "react";
const f = (l) => {
  var m = l, {
    title: a,
    titleId: e
  } = m, t = g(m, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ n.createElement("svg", h({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 24 24", fill: "currentcolor", "aria-labelledby": e }, t), a ? /* @__PURE__ */ n.createElement("title", { id: e }, a) : null, /* @__PURE__ */ n.createElement("g", { transform: "translate(0 1)" }, /* @__PURE__ */ n.createElement("path", { d: "M19308,17619a2.884,2.884,0,0,1-3-2.75.351.351,0,0,1,.006-.078l1-12.25a1,1,0,0,1,.994-.922h3.1a5,5,0,0,1,9.8,0h3.1a1,1,0,0,1,1,.922l1,12.25c0,.025,0,.053,0,.078a2.887,2.887,0,0,1-3,2.75Zm-1-2.717a.932.932,0,0,0,1,.719h14a.929.929,0,0,0,1-.719l-.92-11.281h-14.158Zm10.828-13.283a3,3,0,0,0-5.654,0Z", transform: "translate(-19303 -17598)" })));
};
export {
  f as default
};
